module.exports = __webpack_public_path__ + "static/media/Epic_Senses_-_Ephemeral.b8905b47.mp3";